import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Text from '@polestar/component-warehouse-react/components/text/Text';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import Orientations from '@polestar/component-warehouse-react/tokens/orientations/Orientations';
const KeyValuePair = forwardRef(({ label, value, orientation = Orientations.vertical, ...props }, ref) => {
    return (React.createElement(Container, { ...props, ref: ref, orientation: orientation },
        label && React.createElement(StyledLabel, null, label),
        value && React.createElement(StyledValue, null, value)));
});
KeyValuePair.displayName = 'KeyValuePair';
export default KeyValuePair;
const Container = styled.div(({ orientation }) => css `
    inline-size: 100%;
    display: grid;
    grid-template-columns: ${orientation === Orientations.vertical ? '1fr' : '1fr 1fr'};
    gap: ${Spacings.xxSmall} ${Spacings.medium};
  `);
const StyledLabel = styled(Text)(({ theme }) => css `
    color: ${theme.keyValuePair.label};
  `);
const StyledValue = styled(Text)(({ theme }) => css `
    color: ${theme.keyValuePair.value};
  `);
Container.displayName = `Container`;
